import firebase from 'src/firebase/firebase'

export const getStoreData = async (id: string): Promise<any> => {
  return firebase.db
    .collection('stores')
    .doc(id)
    .get()
    .then((response) => {
      const data = response.data()
      return data
    })
    .catch(() => {
      throw new Error('Hubo un error mientras se intentaba recuperar los datos de la tienda')
    })
}


export const getAllStoresByCompany = async (companyId: string): Promise<any> => {
  try {
    return await firebase.db
      .collection('stores')
      .where('companyId', '==', companyId)
      .get()
      .then((snapshot: any) => {
        if (snapshot.empty) {
          return []
        }
        return snapshot.docs.map((doc: any) => {
          return { id: doc.id, ...doc.data() }
        })
      })
  } catch (error) {
    console.log(error)
    throw new Error('Hubo un error mientras se intentaban recuperar las tiendas de la empresa')
  }
}

export const getAllStores = async (): Promise<any> => {
  try {
    return await firebase.db
      .collection('stores')
      .get()
      .then((snapshot: any) => {
        if (snapshot.empty) {
          return []
        }
        return snapshot.docs.map((doc: any) => {
          return { id: doc.id, ...doc.data() }
        })
      })
  } catch (error) {
    throw new Error('Hubo un error mientras se intentaban recuperar la lista de tiendas ')
  }
}

export const createStore = async (storeData: Record<string, any>): Promise<any> => {
  try {
    return await firebase.db.collection('stores').add(storeData)
    .then(async (docRef) => {
      await firebase.db.collection('stores').doc(docRef.id).update({id:docRef.id})
      })
  } catch (error) {
    throw new Error('Hubo un error mientras se intentaba crear la tienda')
  }
}

export const deleteStore = async (uid: string): Promise<any> => {
  try {
    return firebase.db.collection('stores').doc(uid).update({ deleted: true })
  } catch (error) {
    throw new Error('Hubo un error mientras se intentaba eliminar la tienda')
  }
}

export const updateStore = async (storeData: Record<string, any>, id: string): Promise<any> => {
  delete storeData.id
  delete storeData.createdAt
  try {
    return firebase.db.collection('stores').doc(id).update(storeData)
  } catch (error) {
    throw new Error('Hubo un error mientras se intentaba actualizar los datos de la tienda')
  }
}

export const updateStoreCalendar = async (storeId: string, calendar: Record<string, any>): Promise<any> => {
  try {
    return await firebase.db.collection('stores').doc(storeId).update({ calendar: calendar })
  } catch (error) {
    console.log(error)
    throw new Error('Hubo un error mientras se intentaba actualizar el calendario de la tienda')
  }
}

export interface SlotRef {
  year: number
  month: number // 0-11, como en el calendario de la tienda
  day: number
  hour: string
  minutes: string
}

// Citas no borradas que siguen ocupando la franja: se enseñan al admin antes de liberarla.
export const getActiveBookingsInSlot = async (storeId: string, slot: SlotRef): Promise<{ id: string; patientName: string }[]> => {
  const snapshot = await firebase.db
    .collection('bookings')
    .where('storeId', '==', storeId)
    .where('year', '==', slot.year)
    .where('month', '==', slot.month)
    .where('day', '==', slot.day)
    .get()
  return snapshot.docs
    .map((doc: any) => ({ id: doc.id, ...doc.data() }))
    .filter(
      (b: any) =>
        !b.deleted &&
        String(b.hour).padStart(2, '0') === String(slot.hour).padStart(2, '0') &&
        Number(b.minutes) === Number(slot.minutes)
    )
    .map((b: any) => ({ id: b.id, patientName: b.patient?.name || '' }))
}

// La function pone reserved: false en la franja dentro de una transacción (solo role1).
export const releaseStoreSlot = async (storeId: string, slot: SlotRef): Promise<any> => {
  const releaseSlotCloud = firebase.functions.httpsCallable('releaseSlotCloud')
  try {
    return await releaseSlotCloud({ storeId, ...slot })
  } catch (error: any) {
    console.log(error)
    const msg = error?.message || ''
    if (msg.includes('SLOT_NOT_FOUND')) throw new Error('SLOT_NOT_FOUND')
    throw new Error('Hubo un error mientras se intentaba liberar la franja')
  }
}
